import { render, staticRenderFns } from "./heroAlt.vue?vue&type=template&id=43ef7924"
import script from "./heroAlt.vue?vue&type=script&lang=js"
export * from "./heroAlt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Cta: require('/vercel/path0/components/ui/cta.vue').default})
